<template>
  <div class="footer-container">
    <div class="tva-row">
      <div class="tva-col-md-7 column-1">
        <div class="title" v-html="content.title"></div>
        <div v-html="content.column_1"></div>
      </div>
      <div class="tva-col-md-5 column-2">
        <div v-html="content.column_2"></div>
      </div>
    </div>
  </div>
</template>
<script>
import gsap from "gsap";
import { TimelineMax } from 'gsap'
export default {
  props: ["content"],
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/bootstrap-grid.scss";
@import "@/assets/scss/fonts.scss";
@import "@/assets/scss/colors.scss";
.footer-container{
  position: relative;
  width: 100%;
  background-color: $mdf-darkblue;
  .column-1{
    color: $mdf-white;
    padding-top: 80px;
    padding-bottom: 80px;
    @include mdf-footer-col-1;
  }
  .column-2{
    position: relative;
    @include mdf-footer-col-2;
  }
}

/* Smartphones (portrait and landscape) ----------- */
@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
  .footer-container{
    .column-2{
      padding-bottom: 72px;
    }
  }
}
</style>
